import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const RenameContractModal = ({ show, initialName, onClose, onSubmit }) => {
  const [name, setName] = useState(initialName || "");

  useEffect(() => {
    if (show) setName(initialName || "");
  }, [show, initialName]);

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const trimmed = name.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="contract-modal-dialog contract-create-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>Rename template</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <label className="contract-modal-label">Contract name</label>
          <input
            className="contract-modal-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={!name.trim()}>
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RenameContractModal;
